import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const FiltersIcon = (
    props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
    <svg
        fill="currentColor"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16px"
        height="16px"
        viewBox="0 0 100 100"
        enableBackground="new 0 0 100 100"
        xmlSpace="preserve"
        {...props}
    >
        <g>
            <path d="M90,22.292c0-3.508-2.781-6.359-6.258-6.488v-0.012H16.848v0.018c-0.116-0.006-0.231-0.018-0.348-0.018 c-3.59,0-6.5,2.91-6.5,6.5c0,2.045,0.946,3.867,2.423,5.059l30.14,30.139l-0.001,18.599v0.154h0.015 c0.054,1.204,0.727,2.236,1.713,2.8l-0.009,0.016l7.872,4.545c0.066,0.046,0.139,0.079,0.208,0.12l0.028,0.016l0-0.001 c0.502,0.29,1.078,0.469,1.7,0.469c1.887,0,3.417-1.529,3.416-3.416c0-0.09-0.02-0.175-0.026-0.263h0.026l0-23.011l30.417-30.416 l-0.03-0.03C89.185,25.884,90,24.185,90,22.292z M32.249,28.792h0.014l0.001,0.015L32.249,28.792z" />
        </g>
    </svg>
);
export default FiltersIcon;
